import React, { useState, useEffect } from 'react';
import { CodeIcon, LinkIcon, TypeIcon } from '../icons';
import FolderSelect from './FolderSelect';
import ContentTypeSelect from './ContentTypeSelect';
import OldTextEditor from '../../components/OldTextEditor';
import { AccentButton } from './Button';
import Window from './Window';

const CreateTextItem = ({
  content,
  onCancel,
  onAdd,
  onFolderSelect,
  onContentTypeSelect,
  className = "",
  folderOptions = [],
  defaultFolderId = null
}) => {
  const [selectedFolder, setSelectedFolder] = useState(
    () => folderOptions.find(f => f.value === defaultFolderId) || folderOptions[0] || null
  );
  const [selectedContentType, setSelectedContentType] = useState('plain');
  const [editedContent, setEditedContent] = useState(content);

  useEffect(() => {
    setEditedContent(content);
  }, [content]);

  const contentTypeOptions = [
    {
      value: 'link',
      label: 'Link',
      icon: <LinkIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
    },
    {
      value: 'javascript',
      label: 'JavaScript',
      icon: <CodeIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
    },
    {
      value: 'json',
      label: 'Json',
      icon: <CodeIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
    },
    {
      value: 'yaml',
      label: 'Yaml',
      icon: <CodeIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
    },
    {
      value: 'plain',
      label: 'Plain text',
      icon: <TypeIcon size={16} className="text-[#7B7B7B] dark:text-[#848484]" />
    }
  ];

  const handleFolderChange = (folder) => {
    setSelectedFolder(folder);
    if (onFolderSelect) {
      onFolderSelect(folder);
    }
  };

  const handleNewFolder = () => {
    console.log('Create new folder');
  };

  const handleContentTypeChange = (contentType) => {
    setSelectedContentType(contentType.value);
    if (onContentTypeSelect) {
      onContentTypeSelect(contentType.value);
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleAdd = () => {
    if (onAdd) {
      const blob = new Blob([editedContent ?? content ?? ''], { type: 'text/plain' });
      onAdd(selectedFolder, blob);
    }
  };

  return (
    <Window
      className={className}
      contentClassName="flex flex-col"
      bottomLeft={(
        <>
          <FolderSelect
            value={selectedFolder?.value}
            onChange={handleFolderChange}
            options={folderOptions}
            onNewFolder={handleNewFolder}
            placeholder="F name"
          />
          <ContentTypeSelect
            value={selectedContentType}
            onChange={handleContentTypeChange}
            options={contentTypeOptions}
            placeholder="Code"
          />
        </>
      )}
      bottomRight={(
        <>
          <AccentButton variant="secondary" onClick={handleCancel}>Cancel</AccentButton>
          <AccentButton variant="primary" onClick={handleAdd}>Add</AccentButton>
        </>
      )}
    >
      <div className="w-full h-full flex-1 min-h-0">
        <OldTextEditor
          content={content}
          className="w-full h-full min-h-0"
          readOnly={false}
          language={selectedContentType}
          onChange={(value) => setEditedContent(value)}
        />
      </div>
    </Window>
  );
};

export default CreateTextItem;


